const HubSpotUsersMappings = () => import('@/views/account/integrations/hubspot/mappings/hubspot-users-mappings-view.vue');
const HubSpotCompaniesMappings = () => import('@/views/account/integrations/hubspot/mappings/hubspot-companies-mappings-view.vue');
const HubSpotContactsMappings = () => import('@/views/account/integrations/hubspot/mappings/hubspot-contacts-mappings-view');
const HubSpotActivitiesMappings = () => import('@/views/account/integrations/hubspot/mappings/hubspot-activities-mappings-view');
const HubSpotOpportunitiesMappings = () => import('@/views/account/integrations/hubspot/mappings/hubspot-opportunities-mappings-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/HubSpot/Manage/Users/Mappings',
        name: 'HubSpotUsersMappings',
        component: HubSpotUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Users/Mappings',
        name: 'ClientHubSpotUsersMappings',
        component: HubSpotUsersMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Companies/Mappings',
        name: 'HubSpotCompaniesMappings',
        component: HubSpotCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Companies/Mappings',
        name: 'ClientHubSpotCompaniesMappings',
        component: HubSpotCompaniesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Contacts/Mappings',
        name: 'HubSpotContactsMappings',
        component: HubSpotContactsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Contacts/Mappings',
        name: 'ClientHubSpotContactsMappings',
        component: HubSpotContactsMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Activities/Mappings',
        name: 'HubSpotConnectWiseActivitiesMappings',
        component: HubSpotActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Activities/Mappings',
        name: 'ClientHubSpotActivitiesMappings',
        component: HubSpotActivitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Opportunities/Mappings',
        name: 'HubSpotOpportunitiesMappings',
        component: HubSpotOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Opportunities/Mappings',
        name: 'ClientHubSpotOpportunitiesMappings',
        component: HubSpotOpportunitiesMappings,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account'
        }
    }
]